import { Routes } from '@angular/router';
import { sesionGuard } from '@auth';

/**
 * Toda ruta se carga con `loadComponent`: ninguna pantalla que el usuario no
 * visita entra al bundle inicial.
 *
 * Las rutas de modulo tienen que coincidir con las declaradas en
 * `NavegacionService`. Lo verifica `tools/audit-arquitectura.mjs` (R4), porque
 * un desajuste se manifiesta como un item de menu que no navega, sin error.
 */
export const routes: Routes = [
  {
    path: 'inicio',
    canActivate: [sesionGuard],
    loadComponent: () => import('./pages/inicio/inicio.page').then((m) => m.InicioPage),
  },
  // ── ACCESO ────────────────────────────────────────────────────────────────
  //
  // Las pantallas cuelgan de su grupo, y eso NO es cosmetica de la URL: el riel
  // muestra «Acceso» y resalta por PREFIJO, asi que estando en `/acceso/roles`
  // el item correcto se enciende solo. Con `/roles` suelto no se encenderia
  // ninguno — el riel no tendria a que casar— y el usuario no sabria donde esta.
  {
    path: 'acceso',
    canActivate: [sesionGuard],
    data: { grupo: 'acceso' },
    loadComponent: () => import('./pages/hub/hub.page').then((m) => m.HubPage),
  },
  {
    path: 'acceso/aplicaciones',
    canActivate: [sesionGuard],
    loadComponent: () =>
      import('./pages/aplicaciones/aplicaciones.page').then((m) => m.AplicacionesPage),
  },
  {
    path: 'acceso/roles',
    canActivate: [sesionGuard],
    loadComponent: () => import('./pages/roles/roles.page').then((m) => m.RolesPage),
  },
  {
    path: 'acceso/cuentas',
    canActivate: [sesionGuard],
    loadComponent: () => import('./pages/cuentas/cuentas.page').then((m) => m.CuentasPage),
  },
  // ── BITACORA ──────────────────────────────────────────────────────────────
  //
  // Suelta, sin grupo: cruza todos los esquemas que vigila el disparador.
  {
    path: 'bitacora',
    canActivate: [sesionGuard],
    loadComponent: () => import('./pages/bitacora/bitacora.page').then((m) => m.BitacoraPage),
  },

  // Suelta, sin grupo: los catalogos viven en tres bases (dbusers, dbfact y
  // dbservicio), asi que no corresponden a ningun grupo del riel. Una sola
  // pagina para el selector y para cada catalogo.
  {
    path: 'catalogos',
    canActivate: [sesionGuard],
    loadComponent: () => import('./pages/catalogos/catalogos.page').then((m) => m.CatalogosPage),
  },
  {
    path: 'catalogos/:clave',
    canActivate: [sesionGuard],
    loadComponent: () => import('./pages/catalogos/catalogos.page').then((m) => m.CatalogosPage),
  },

  // ── Las rutas ANTERIORES, redirigidas ─────────────────────────────────────
  //
  // No son cortesia: son las URLs que estan en los marcadores del equipo y en
  // la barra de direcciones de quien ya tenia la pantalla abierta. Sin esto, un
  // `/roles` guardado cae en el `**` y aterriza en inicio, que se lee como
  // «esa pantalla ya no existe».
  //
  // Se quitan cuando nadie las use. Mientras tanto cuestan tres lineas.
  //
  // ⚠️ Las de `empleados`, `vacaciones` y `empresas` se fueron CON sus pantallas
  // el 2026-10-02, y es lo correcto: un redirect a una ruta que ya no existe
  // cae igual en el `**`, pero por un camino mas largo y con una promesa de por
  // medio.
  { path: 'aplicaciones', pathMatch: 'full', redirectTo: 'acceso/aplicaciones' },
  { path: 'roles', pathMatch: 'full', redirectTo: 'acceso/roles' },
  { path: 'cuentas', pathMatch: 'full', redirectTo: 'acceso/cuentas' },
  { path: '', pathMatch: 'full', redirectTo: 'inicio' },
  { path: '**', redirectTo: 'inicio' },
];
